$.handleBroadcastEvent = function (payload) {
    console.log(payload);
}

$.askNotificationPermission = function () {
    return new Promise(function (resolve, reject) {
        const permissionResult = Notification.requestPermission(function (result) {
            resolve(result);
        });

        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    }).then(function (permissionResult) {
        if (permissionResult !== 'granted') {
            throw new Error('We weren\'t granted permission.');
        }
    });
}

$.subscribeUserToPushNotification = function () {
    return navigator.serviceWorker.ready.then(function (registration) {
        return registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(process.env.MIX_VAPID_PUBLIC_KEY),
        }).then(function (subscription) {
            const key = subscription.getKey('p256dh');
            const token = subscription.getKey('auth');

            $.ajax({
                type: 'POST',
                url: '/web-push/subscribe',
                data: {
                    endpoint: subscription.endpoint,
                    publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                    authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
                    contentEncoding: (PushManager.supportedContentEncodings || ['aesgcm'])[0],
                }, beforeSend: function () {
                },
            });
        });
    });
}

$.unsubscribeUserFromPushNotification = function () {
    return navigator.serviceWorker.ready.then(function (registration) {
        return registration.pushManager.getSubscription().then(function (subscription) {
            subscription.unsubscribe();

            $.ajax({
                type: 'POST',
                url: '/web-push/unsubscribe',
                data: {
                    endpoint: subscription.endpoint,
                }, beforeSend: function () {
                },
            });
        });
    });
}

// Convert public vavid key to base64String
var urlBase64ToUint8Array = function (base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}
